import React from "react";
import { type IIconInterface } from "../icon.interface";
import { SvgIcon } from "../SvgIcon";

export const OfficeIcon: React.FC<IIconInterface> = (props): JSX.Element => {
  return (
    <SvgIcon title="Office" viewBox="0 0 24 24" {...props}>
      <path
        d="M20.25 6.75H3.75C3.33579 6.75 3 7.08579 3 7.5V19.5C3 19.9142 3.33579 20.25 3.75 20.25H20.25C20.6642 20.25 21 19.9142 21 19.5V7.5C21 7.08579 20.6642 6.75 20.25 6.75Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.75 6.75V5.25C15.75 4.85218 15.592 4.47064 15.3107 4.18934C15.0294 3.90804 14.6478 3.75 14.25 3.75H9.75C9.35218 3.75 8.97064 3.90804 8.68934 4.18934C8.40804 4.47064 8.25 4.85218 8.25 5.25V6.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M3 15H21" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
  );
};
